import { PaymentMethodTypeEnum } from 'src/interfaces/paymentMethod'

export type CardData = {
  type: PaymentMethodTypeEnum.Card
  lastDigits?: string
  expiration?: string
}

export type BankData = {
  type: PaymentMethodTypeEnum.BankAccount
  accountLastDigits?: string
  routingLastDigits?: string
}
export type PaymentData = CardData | BankData | null

export const getPaymentMethodDetails = (methodDetails: PaymentData): string => {
  if (!methodDetails) {
    return ''
  }
  const isCardData = (methodDetails: PaymentData): methodDetails is CardData => {
    return methodDetails?.type === PaymentMethodTypeEnum.Card
  }
  const isBankData = (methodDetails: PaymentData): methodDetails is BankData => {
    return methodDetails?.type === PaymentMethodTypeEnum.BankAccount
  }

  if (isCardData(methodDetails)) {
    const last4 = methodDetails.lastDigits || ''
    const exp = methodDetails.expiration || ''
    let formattedExp = exp

    if (exp.includes('-')) {
      const [mm, yyyy] = exp.split('-')
      const yy = (yyyy || '').slice(-2)
      formattedExp = mm && yy ? `${mm}/${yy}` : exp
    }

    return formattedExp ? `** ${last4} • ${formattedExp}` : `** ${last4}`
  }

  if (isBankData(methodDetails)) {
    const accountLast4 = methodDetails.accountLastDigits || ''
    const routingLast4 = methodDetails.routingLastDigits || ''

    if (accountLast4 && routingLast4) {
      return `** ${accountLast4} • ** ${routingLast4}`
    }

    if (accountLast4) {
      return `** ${accountLast4}`
    }

    return ''
  }

  return ''
}
